import axiosInstance from "./axiosInstance";

const unwrapBlob = async (promise, fallbackName) => {
  const res = await promise;
  const blob = new Blob([res.data], {
    type:
      res.headers["content-type"] ||
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fallbackName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

export const getTransactionReport = async (params = {}) => {
  try {
    const res = await axiosInstance.get("/api/reports/transactions", { params });
    return {
      success: true,
      data: res.data?.data || {},
      message: res.data?.message,
    };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || "Failed to load report",
    };
  }
};

export const exportTransactionReport = async (params = {}) => {
  try {
    const service = String(params.service || "all").toLowerCase();
    await unwrapBlob(
      axiosInstance.get("/api/reports/transactions/export", {
        params,
        responseType: "blob",
      }),
      `txn-report-${service}.xlsx`
    );
    return { success: true };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || "Report export failed",
    };
  }
};
